module.exports = __webpack_public_path__ + "img/photo-22.2002e242.webp";